import cx from 'classnames';
import { bool, arrayOf, number, shape } from 'prop-types';
import CustomizeProduct from '../Product/CustomizeProduct';
import * as classNames from './ProductContainer.module.css';

const ProductContainerCustomizations = (props) => {
  const {
    exploreDisplay = false,
    products = [],
    open,
    viewAll,
    initialDisplayAmount,
    isMobile,
    isSelect,
    isProspect,
  } = props;
  const responsive = (className) => cx(className);

  return (
    <div className={responsive(classNames.container)}>
      {}
      {products.map((item, index) => {
        const hideItem = !viewAll && index > initialDisplayAmount - 1;
        if (item) {
          const itemDivKey = `item-${index}`;
          return (
            <div
              key={itemDivKey}
              style={{ display: hideItem ? 'none' : 'inherit' }}
              className={responsive(classNames.productContainer)}
            >
              <CustomizeProduct
                exploreDisplay={exploreDisplay}
                {...item}
                open={open}
                isSelect={isSelect}
                isProspect={isProspect}
              />
              {isMobile && index < products.length - 1 && <div className={classNames.horRule} />}
            </div>
          );
        }
      })}
    </div>
  );
};

ProductContainerCustomizations.propTypes = {
  exploreDisplay: bool,
  products: arrayOf(shape({})),
  open: bool.isRequired,
  viewAll: bool.isRequired,
  initialDisplayAmount: number.isRequired,
  isMobile: bool.isRequired,
  isSelect: bool.isRequired,
  isProspect: bool.isRequired,
};

export default ProductContainerCustomizations;
